import { render, staticRenderFns } from "./PromoBookClassic.vue?vue&type=template&id=397c2f2d&scoped=true"
import script from "./PromoBookClassic.vue?vue&type=script&lang=js"
export * from "./PromoBookClassic.vue?vue&type=script&lang=js"
import style0 from "./PromoBookClassic.vue?vue&type=style&index=0&id=397c2f2d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397c2f2d",
  null
  
)

export default component.exports